import React from 'react'
import { Slider } from 'antd';
import SliderTitle from './SliderTitle';
import SliderMax from './SliderMax';

const SliderBar = (props) => {
    const { sliderTitle, range, onAfterChange, marks, max, sliderTitleDesc } = props
    // const defalutValue = [0, 3 * max / 4]
    return (
        <div>
            <SliderTitle sliderTitle={sliderTitle} range={range}  max={max} sliderTitleDesc={sliderTitleDesc} /> {/*垃圾 PM 把資料項說明傳給 sliderTitle*/}
            {max <= 100 && <Slider range step={.1} defaultValue={range} onAfterChange={onAfterChange} marks={marks} max={max} />}
            {max > 100 && max < 1000000 && <Slider range step={1000} defaultValue={range} onAfterChange={onAfterChange} marks={marks} max={max} />}
            {max >= 1000000 && <Slider range step={10000} defaultValue={range} onAfterChange={onAfterChange} marks={marks} max={max} />}
            <SliderMax sliderTitle={sliderTitle} max={max}/>
        </div>
    );
}
export default SliderBar;


// WEBPACK FOOTER //
// ./src/InfoList/Search/dev/SliderBarSearch/SliderBar.js